export const wrapperClasses = 'relative inline-flex self-start -mt-1 lg:mt-0';

export const containerClasses =
  'inline-flex items-center gap-1 bg-[#fff] bg-opacity-[.85] pl-1 py-0.5 pr-3.5 lg:py-1 lg:pr-[18px] [clip-path:polygon(0_0,calc(100%-1px)_0,calc(100%-14px)_100%,0_100%)] lg:[clip-path:polygon(0_0,calc(100%-1px)_0,calc(100%-17px)_100%,0_100%)]';

export const diagonalClasses = 'absolute top-0 right-0 h-full w-0.5 skew-x-[-35deg] origin-top-right bg-yellow-400';

export const labelClasses = 'inline-flex items-center gap-1 text-[10px] lg:text-xs leading-[14px]';

export const tooltipClasses = 'p-3 text-sm zappos:body-s shadow-lg rounded-lg bg-default-minimal text-base';
